<template>
  <div class="user_all" v-loading="fullscreenLoading">
    <div class="user_search" style="margin:0;">
      <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
      <el-select style="width: 250px" v-model="selectRpc" @change="changeRpc()" :placeholder="this.$t('title.RPC_service')">
        <el-option
          v-for="item in optionRpc"
          :key="item.rpcUrl"
          :label="item.name"
          :value="item.rpcUrl"
        ></el-option>
      </el-select>

      <!--            <el-button type="primary" style="margin-left: 5%" @click="searchRpc()" :loading=isResponse>查询</el-button>-->
      <el-button
        v-if="roles.name == 'agan'"
        type="primary"
        style="margin-left:30px"
        @click="posChain()"
      >{{ $t('title.Reward_on_POS_chain') }}</el-button>
      <el-button
        v-if="roles.name == 'agan'"
        type="primary"
        style="margin-left:30px"
        @click="posNode()"
      >{{ $t('title.POS_node_awards') }}</el-button>
    </div>
    <p style="color:red;margin-bottom:0">{{ $t('title.UserA_to_userB1') }}</p>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.Owning_chain') }}：</span>
      <el-select
        style="width: 100px;margin-right:20px"
        v-model="selectChainA"
        @change="changeChain(1)"
        :placeholder="$t('title.Please_select_the_chain')"
      >
        <el-option v-for="item in optionsChain" :key="item" :label="item+$t('title.chain')" :value="item"></el-option>
      </el-select>
      <span style="width: 70px;display: inline-block">{{ $t('title.UserA') }}：</span>
      <el-select
        style="width: 540px;margin-top:20px;"
        v-model="selectUserA"
        @change="changeUserA()"
        :placeholder="this.$t('title.please_choose')"
      >
        <el-option
          v-for="item in userA"
          :key="item.id"
          :label="`${item.nickname} - ${item.address}`"
          :value="item.id"
        ></el-option>
      </el-select>
      <span style="margin-left: 10px;display: inline-block">{{ $t('title.Balance') }}：</span>
      <span style="display: inline-block;margin-left: 10px;">{{xtA}}</span>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.Owning_chain') }}：</span>
      <el-select
        style="width: 100px;margin-right:20px"
        v-model="selectChainB"
        @change="changeChain(2)"
        :placeholder="$t('title.Please_select_the_chain')"
      >
        <el-option v-for="item in optionsChain" :key="item" :label="item+$t('title.chain')" :value="item"></el-option>
      </el-select>
      <span style="width: 70px;display: inline-block;">{{ $t('title.UserB') }}：</span>
      <el-select
        v-if="selectInputIsShow"
        style="width: 540px;"
        v-model="selectUserB"
        @change="changeUserB()"
        :placeholder="this.$t('title.please_choose')"
      >
        <el-option
          v-if="selectInputIsShow"
          v-for="item in userB"
          :key="item.id"
          :label="`${item.nickname} - ${item.address}`"
          :value="item.id"
        ></el-option>
      </el-select>
      <span v-if="selectInputIsShow" style="margin-left: 10px;display:inline-block;">{{ $t('title.Balance') }}：</span>
      <span v-if="selectInputIsShow" style="display: inline-block;margin-left: 10px">{{xtB}}</span>
    </div>
    <div class="user_search">
      <el-input
        v-model="inputAddress"
        type="textarea"
        @blur.native.capture="inputAddressBlur"
        style="width: 420px;"
        :rows="6"
        :placeholder="`${$t('title.designated_address')}${$t('title.designated_placeholder1')}
${$t('title.designated_placeholder2')}
${$t('title.designated_placeholder3')}
0x1234,1000;
0x2345,2000;
0x7890,3000;
....`"
      ></el-input>
    </div>
    <div class="user_search" style="display: flex;align-items:center;">
      <span v-if="selectInputIsShow" style="width: 100px;display: inline-block">{{ $t('title.transfer_amount') }}：</span>
      <el-input
        v-if="selectInputIsShow"
        v-model="inputValue"
        type="primary"
        style="width: 250px"
        oninput="value=value.replace(/[^0-9.]/g,'')"
        :placeholder="this.$t('title.Please_enter_the_transfer_amount')"
      ></el-input>
      <el-button type="primary" style="margin-left: 30px" @click="tranfser" :loading="isResponse">{{ $t('title.transfer') }}</el-button>
    </div>

    <div class="user_search" style="float: right">
      <el-input v-model="seaAdds" type="primary" style="width: 370px" :placeholder="this.$t('title.Please_enter_the_address')"></el-input>
      <el-button type="primary" style="margin-left: 30px" @click="searAdd(currentPage)">{{ $t('title.search') }}</el-button>
    </div>

    <div class="con_table">
      <el-table
        :data="tableData"
        border
        height="520"
        style="width: 100%;margin-bottom: 30px;margin-top: 40px"
        :header-cell-style="this.tableHeaderColor"
      >
        <el-table-column fixed :label="this.$t('title.Serial_number')" align="center" width="90">
          <template slot-scope="scope">
            <span>{{scope.row.id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Hash" width="400" align="center">
          <template slot-scope="scope">
            <el-link
              @click="$refs.searchHash.open(scope.row.hash, scope.row.rpcServer, scope.row.fromChainId, optionRpc)"
              :underline="false"
              type="primary"
            >{{scope.row.hash}}</el-link>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.RPC_service')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.rpcServer}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Chain_id')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromChainId}}</span>
          </template>
        </el-table-column>
        <!--                <el-table-column-->
        <!--                        label="转账方名称"-->
        <!--                        align="center">-->
        <!--                    <template slot-scope="scope">-->
        <!--                        <span>{{scope.row.fromAddress}}</span>-->

        <!--                    </template>-->
        <!--                </el-table-column>-->
        <el-table-column :label="this.$t('title.Transfer_address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.fromAddress)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_before_transfer')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromBeforeCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_after_transfer')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.fromAfterCoins}}</span>
          </template>
        </el-table-column>
        <!--                <el-table-column-->
        <!--                        label="收款方名称"-->
        <!--                        align="center">-->
        <!--                    <template slot-scope="scope">-->
        <!--                        <span>{{timestampToTime(scope.row.createTime)}}</span>-->
        <!--                    </template>-->
        <!--                </el-table-column>-->
        <el-table-column  :label="this.$t('title.Payee_address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.toAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.toAddress)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_before_payment')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.toBeforeCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Amount_after_receipt')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.toAfterCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.amount')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.coins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Gas_fee')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.gasFee}}</span>
          </template>
        </el-table-column>
        <el-table-column label="GasUsed" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.gasUsed}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('title.state')" fixed="right" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.status==-1? $t('title.Sent_awaiting_verification') :scope.row.status==-1? $t('title.failure') : $t('title.success') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total,prev, pager, next"
        :total="total"
      ></el-pagination>
      <!-- 交易查询结果 -->
      <SearchHash ref="searchHash" />
    </div>
  </div>
</template>

<script>
import {
  getrpcserver,
  getchaininfo,
  chainSendTx,
  getaccount,
  userlList,
  transferList,
  chainSendTxBatch
} from "../../../api/interface";
import SearchHash from "../../SearchHash";
import { mapState } from "vuex";
export default {
  name: "Transfer",
  components: { SearchHash },
  data() {
    return {
      tableData: [],
      tableDataB: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      isResponse: false,
      selectRpc: "",
      seleArr: [],
      optionRpc: [],
      selectChain: "",
      selectChainA: "",
      selectChainB: "",
      optionsChain: [],
      inputValue: "",
      searchValue: "",
      userA: [],
      userB: [],
      selectUserA: "",
      selectUserB: "",
      inputAddress: "",
      selectInputIsShow: true,
      fullscreenLoading: false,
      xtA: "",
      xtB: "",
      xtC: "",
      seaAdds: "",
      data: {},
      paramsList: []
    };
  },
  methods: {
    getUserList() {
      let data = {
        rpcServer: this.selectRpc,
        chainId: this.selectChainA || this.selectChainB,
        address: "",
        page: 1,
        rows: 10000
      };
      userlList(data).then(response => {
        if (response.code == 200) {
          this.fullscreenLoading = false;
          this.userA = response.data.data;
          this.userB = response.data.data;
          console.log("this.selectUserA000", this.selectUserA);
          console.log("this.selectUserB000", this.selectUserB);
          this.selectUserA = response.data.data[0].id;
          this.selectUserB = response.data.data[0].id;
          this.changeUserA();
          this.changeUserB();
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    searAdd(currentPage) {
      let a = {
        type: "101",
        page: currentPage,
        rows: 10,
        address: this.seaAdds
      };
      transferList(a).then(response => {
        this.isResponse = false;
        if (response.code == 200) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(response.msg);
        }
      });
    },
    posChain() {
      // console.log("pos链上发奖");
      this.selectRpc = this.optionRpc[1].rpcUrl;
      // console.log("RPC服务", this.selectRpc);
      this.selectChainA = this.optionsChain[0];
      // console.log("所属链A", this.selectChainA);
      this.selectChainB = this.optionsChain[1];
      // console.log("所属链B", this.selectChainB);
      this.inputValue = 1000000;
      // console.log("用户A", this.selectUserA);
      // console.log("用户B", this.selectUserB);
      // console.log("用户A List", this.userA);
      // console.log("用户B List", this.userB);

      let defaultSelectUserA = "0x6b16d92dd45ae1450f981f6ad17e0b8f1d51d194";
      let defaultSelectUserB = "0x1111111111111111111111111111111111111111";

      let obj = {}; //定义对象集合
      obj = this.userA.find((item, index) => {
        //projectlist 为Select遍历集合 project 为Select 遍历 对象
        return item.address == defaultSelectUserA; //筛选出匹配数据 返回对象
      });

      if (obj) {
        this.selectUserA = obj.id;
      }
      // console.log("this.selectChainA", this.selectChainA);
      // console.log("obj", obj);
      let obj2 = {}; //定义对象集合
      obj2 = this.userB.find((item, index) => {
        //projectlist 为Select遍历集合 project 为Select 遍历 对象
        return item.address == defaultSelectUserB; //筛选出匹配数据 返回对象
      });
      if (obj2) {
        this.selectUserB = obj2.id;
      }
      // console.log("obj2", obj2);
    },
    posNode() {
      // console.log("pos节点发奖");
      // console.log("用户A", this.selectUserA);
      // console.log("用户B", this.selectUserB);
      // console.log("用户A List", this.userA);
      // console.log("用户B List", this.userB);
      let defaultNodeSelectUserA = "0x6b16d92dd45ae1450f981f6ad17e0b8f1d51d194";
      let defaultNodeSelectUserB = "0xde31c853e3356d39ae4ce4ee81841a5a9f4599a9";
      let objs = {}; //定义对象集合
      objs = this.userA.find((item, index) => {
        //projectlist 为Select遍历集合 project 为Select 遍历 对象
        return item.address == defaultNodeSelectUserA; //筛选出匹配数据 返回对象
      });

      if (objs) {
        this.selectUserA = objs.id;
      }
      // console.log("objs", objs);
      let objs2 = {}; //定义对象集合
      objs2 = this.userB.find((item, index) => {
        //projectlist 为Select遍历集合 project 为Select 遍历 对象
        return item.address == defaultNodeSelectUserB; //筛选出匹配数据 返回对象
      });

      if (objs2) {
        this.selectUserB = objs2.id;
      }
      console.log("objs2", objs2);
    },
    changeRpc() {
      // this.fullscreenLoading = true;
      console.log("this.selectRpc", this.selectRpc);
      let data = { rpcServer: this.selectRpc };
      getchaininfo(data).then(response => {
        this.optionsChain = response.data;
        this.selectChainA = this.optionsChain[0];
        console.log("00000", this.selectChainA);
        this.selectChainB = this.optionsChain[0];

        // this.getUserList();
        this.changeUserA();
        this.changeUserB();
      });
    },
    currentPageChange(e) {
      this.currentPage = e;
      this.searAdd(this.currentPage);
    },
    changeChain(userType) {
      console.log("userType", userType);
      if (userType == "1") {
        this.changeUserA();
      } else if (userType == "2") {
        this.changeUserB();
      }
      // this.fullscreenLoading = true;
      // this.getUserList(userType);
    },
    changeUserA() {
      console.log("0000", this.selectUserA);
      let aa = "";
      this.userA.forEach((item, index, self) => {
        if (item.id == this.selectUserA) {
          aa = item.address;
        }
      });
      this.getAccount(aa, this.selectChainA, this.selectRpc, "a");
      // this.userA.forEach((item, index, self) => {
      //   if (item.id == this.selectUserA) {
      //     this.xtA = item.coins;
      //   }
      // });
    },
    changeUserB() {
      console.log("00001", this.selectUserB);
      let bb = "";
      if (!this.inputAddress) {
        this.userB.forEach((item, index, self) => {
          if (item.id == this.selectUserB) {
            bb = item.address;
          }
        });
      }else{
        bb = this.inputAddress
      }

      console.log('---bb', bb);
      console.log('---this.inputAddress', this.inputAddress);
      this.getAccount(bb, this.selectChainB, this.selectRpc, "b");
      // console.log(this.userB, 1111);
      // this.userB.forEach((item, index, self) => {
      //   if (item.id == this.selectUserB) {
      //     this.xtB = item.coins;
      //   }
      // });
    },
    getAccount(address, chainId, rpcServer, type) {
      console.log("address, chainId, rpcServer, type", address, chainId, rpcServer, type);
      if(!address || !chainId || !rpcServer || !type){
        return;
      }
      console.log('111111')
      getaccount({
        address,
        chainId,
        rpcServer
      }).then(res => {
         console.log("查询余额1111");
        if (res.code == 200) {
          console.log("查询余额", res);
          if (type == "a") {
            console.log("type为a", type);
            this.xtA = res.data.balanceValue;
          } else if (type == "b") {
            console.log("type为b", type);
            this.xtB = res.data.balanceValue;
          } 
          // this.tableDataB = [];
        }
      });
    },

    getData() {
      getrpcserver().then(response => {
        this.optionRpc = response.data;
        this.selectRpc = this.optionRpc[0].rpcUrl;
        let data = { rpcServer: this.optionRpc[0].rpcUrl };
        getchaininfo(data).then(response => {
          this.optionsChain = response.data;
          this.selectChainA = this.optionsChain[0];
          console.log("1212121", this.optionsChain[0]);
          this.selectChainB = this.optionsChain[0];
          this.getUserList();
        });
      });
    },
    inputAddressBlur() {
      // console.log("我是指定地址失焦了", this.inputAddress);
      // console.log("数据", this.tableDataB);
      // if (this.inputAddress == "") {
      //   this.$message.error("请输入地址！");
      //   return false;
      // }
      this.paramsList = []
      if (this.inputAddress === "") {
        this.selectInputIsShow = true;
        this.userB.forEach((item, index, self) => {
          if (item.id == this.selectUserB) {
            address = item.address;
          }
        });
        return false
      } else {
        this.selectInputIsShow = false;
      }
      let str = this.inputAddress.replace(/\n/g,'')
      let arr = str.split(';')
      try {
        arr.forEach((item) => {
          if (item) {
            let address = item.split(',')[0]
            let coins = item.split(',')[1]
            if (address.startsWith("TH")) {
              address = this.to_16_decimal(address);
            }
            console.log(address,coins,111)
            if (address == "" || address.length != 42) {
              this.$message.error("Please enter the correct address!");
              return false;
            } else if (!coins || coins == "" || coins != Number(coins) || Number(coins) == 0) {
              this.$message.error("Please enter the correct format!");
              return false;
            } else {
              this.paramsList.push({
                toAddress: address,
                coins: coins
              })
            }
          }
        })
      } catch(e) {
        this.$message.error("Please enter the correct format!");
        return false;
      }
      let address;
      address = this.inputAddress

      /* this.getAccount(
          address,
          this.selectChainB,
          this.selectRpc,
          "b"
        ); */

      // let obj = {}; //定义对象集合
      // obj = this.tableDataB.find((item, index) => {
      //   return item.fromAddress == this.inputAddress; //筛选出匹配数据 返回对象
      // });

      // if (obj) {
      //   console.log("找到了", obj);
      //   this.xtB = obj.coins;
      // } else {
      //   console.log("没找到", obj);
      //   this.xtB = 0;
      // }
    },
    verification() {
      /* if (this.inputAddress != "" && this.inputAddress.length != 42) {
        this.$message.error("Please enter the correct address!");
        return false;
      } */
      if (
        this.selectUserA == "" ||
        (this.selectUserB == "" && this.inputAddress == "")
      ) {
        this.$message.error("Please select the transferor and receiver before proceeding with the transfer operation!");
        return false;
      }
      if (this.inputAddress == "" && this.inputValue == "") {
        this.$message.error("Please enter the transfer amount correctly!");
        return false;
      }
      if (this.inputAddress && !this.paramsList.length ) {
        this.$message.error("Please enter the correct format!");
        return false;
      }
      // //获取AB选框的地址
      // let addressA, addressB;
      // this.userB.forEach((item, index, self) => {
      //   if (item.id == this.selectUserB) {
      //     addressB = item.address;
      //   }
      // });
      // this.userA.forEach((item, index, self) => {
      //   if (item.id == this.selectUserA) {
      //     addressA = item.address;
      //   }
      // });

      //B地址可选可输入拿到最终的数据进行对比
      // let userAddressB = this.inputAddress || addressB;
      // if (addressA == userAddressB && this.selectChainA == this.selectChainB) {
      //   this.$message.error("同链转账人与接收人不能为同一地址！");
      //   return false;
      // }
      return true;
    },
    tranfser() {
      if (this.inputAddress && !this.paramsList.length) {
        this.inputAddressBlur()
        if (!this.paramsList.length) {
          return
        }
      }
      if (!this.verification()) {
        return;
      }
      let aa = "";
      let bb = "";

      this.userA.forEach((item, index, self) => {
        if (item.id == this.selectUserA) {
          aa = item.address;
        }
      });
      this.userB.forEach((item, index, self) => {
        if (item.id == this.selectUserB) {
          bb = item.address;
        }
      });
      //若B地址输入了指定地址则以输入转账，若没有输入则以选中转账
      let PostFun = null
      let userAddressB = bb;
      let sendRpc = ""
      this.optionRpc.forEach(item => {
        if(item.rpcUrl == this.selectRpc){
          sendRpc = JSON.parse(item.description)[this.selectChainB]
          console.log(JSON.parse(item.description)[this.selectChainB],45445)
        }
      });
      if (this.inputAddress) {
        let flag = true
        this.paramsList.forEach((item) => {
          if (aa == item.toAddress && this.selectChainA == this.selectChainB) {
            this.$message.error("The same chain transferor and recipient cannot be the same address！");
            flag = false
          } else {
            item.fromAddress = aa
            item.chainId = this.selectChainA
            item.toChainId = this.selectChainB
            item.rpcServer = sendRpc
          }
        })
        if (flag) {
          this.data = {paramsList: this.paramsList}
          PostFun = chainSendTxBatch
        } else {
          return false
        }
      } else {
        if (aa == userAddressB && this.selectChainA == this.selectChainB) {
          this.$message.error("The same chain transferor and recipient cannot be the same address！");
          return false;
        } else {
          console.log("选中地址");
          this.data = {
            fromAddress: aa,
            toAddress: bb,
            chainId: this.selectChainA,
            toChainId: this.selectChainB,
            rpcServer: sendRpc,
            coins: this.inputValue
          };
          PostFun = chainSendTx
        }
      }
      console.log("data", this.data);
      this.isResponse = true;
      PostFun(this.data).then(response => {
        this.isResponse = false;
        if (response.code == 200) {
          let a = {
            type: "101",
            page: 1,
            rows: 10
          };
          this.$message.success("Success！");
          this.fullscreenLoading = true;
          setTimeout(() => {
            // this.getData();
            this.getAccount(
              aa,
              this.selectChainA,
              this.selectRpc,
              "a"
            );
            userAddressB && this.getAccount(
              userAddressB,
              this.selectChainB,
              this.selectRpc,
              "b"
            );
            // this.inputAddress = "";
            this.inputValue = "";
            this.paramsList = []
            transferList(a).then(response => {
              if (response.code == 200) {
                this.tableData = response.data.data;
                this.fullscreenLoading = false;
              } else {
                this.tableData = [];
              }
            });
          }, 6000);
        } else {
          this.$message.error(response.msg);
        }
      });
    }
  },
  computed: {
    ...mapState({
      roles: state => state.app.roles
    }),
    iconColor() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    }
  },
  created() {
    this.getData();
    this.searAdd(this.currentPage);
  },
  activated() {
    this.searAdd(this.currentPage);
  }
};
</script>
<style scoped>
.user_all {
  padding: 20px 30px;
}

.user_search {
  margin-bottom: 20px;
}
</style>